import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

import { usePlaybackSuggestions } from '../hooks/store';
import { useIsClubPage } from '../hooks/config';

import CarouselRow from '../components/CarouselRow';
import { QUERY_PARAMS } from '../utils/constants';

const SuggestionsRow = forwardRef((props, ref) => {

    const {
        properties,
        rank,
        skip,
    } = props;
    const {
        title, carouselType, experience,
    } = properties;
    const {
        loading,
        data,
        error,
    } = usePlaybackSuggestions(experience, { skip });
    const isClubPage = useIsClubPage();

    if (error || isClubPage) {

        return null;

    }

    return (
        <CarouselRow
            ref={ref}
            title={title}
            rank={rank}
            type={carouselType}
            list={data}
            isLoading={loading}
            searchParams={`?${QUERY_PARAMS.suggestionsModel}=${experience}&${QUERY_PARAMS.playlistTitle}=${title}`}
        />
    );

});

SuggestionsRow.propTypes = {
    rank: PropTypes.number.isRequired,
    skip: PropTypes.bool,
    properties: PropTypes.object,
};

SuggestionsRow.defaultProps = {
    ssr: false,
    properties: {},
};

export default SuggestionsRow;
